var _circle, _path, _circle2, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQuoted = function SvgQuoted(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#B2C9DE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M6.856 6.855a.643.643 0 0 0-.643.643v7.715c0 1.42 1.15 2.57 2.57 2.571h6.43c.98 0 1.656-.423 2.064-.99a2.796 2.796 0 0 0 .507-1.581.643.643 0 0 0-.642-.643h-1.93V7.498a.643.643 0 0 0-.642-.643H6.856Zm3.857 7.715h3.214V8.14H7.5v7.072c0 .71.575 1.285 1.285 1.285h.002c.218 0 .56-.07.828-.264.236-.17.456-.46.456-1.021 0-.355.288-.643.643-.643Zm.34 1.928h4.16c.562 0 .85-.22 1.021-.456.043-.06.08-.122.111-.187h-5.056a2.448 2.448 0 0 1-.236.643ZM8.784 10.07c0-.355.288-.643.643-.643H12a.643.643 0 0 1 0 1.286H9.427a.643.643 0 0 1-.643-.643Zm.643 1.285a.643.643 0 1 0 0 1.286H12a.643.643 0 0 0 0-1.286H9.427Z",
    clipRule: "evenodd"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#B2C9DE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M6.466 6.4a.7.7 0 0 0-.7.7v8.4a2.8 2.8 0 0 0 2.8 2.8h7c1.068 0 1.803-.46 2.248-1.079.419-.582.552-1.26.552-1.721a.7.7 0 0 0-.7-.7h-2.1V7.1a.7.7 0 0 0-.7-.7h-8.4Zm4.2 8.4h3.5v-7h-7v7.7a1.4 1.4 0 0 0 1.4 1.4c.238 0 .61-.077.903-.288.257-.185.497-.5.497-1.112a.7.7 0 0 1 .7-.7Zm.37 2.1h4.53c.611 0 .926-.24 1.112-.497.046-.064.086-.133.12-.203h-5.505a2.671 2.671 0 0 1-.257.7Zm-2.47-7a.7.7 0 0 1 .7-.7h2.8a.7.7 0 1 1 0 1.4h-2.8a.7.7 0 0 1-.7-.7Zm.7 1.4a.7.7 0 0 0 0 1.4h2.8a.7.7 0 1 0 0-1.4h-2.8Z",
    clipRule: "evenodd"
  })));
};
export default SvgQuoted;